import { createStore as createUsersStore } from '@md/users/store'
import { createStore as createCartStore } from '@md/cart/store'
import { createStore as createProfileStore } from '@md/profile/store'
import { createStore as createCatalogStore } from '@md/catalog/store'

export function createStore(parameters) {
  return {
    modules: {
      users: createUsersStore(parameters),
      cart: createCartStore(parameters),
      profile: createProfileStore(parameters),
      catalog: createCatalogStore(parameters),
    },
  };
}

export function createStoreObject({ Store, Vue }) {
  return new Store(createStore({ Store, Vue }));
}
